import { render, staticRenderFns } from "./ErrosSync.vue?vue&type=template&id=46847004&"
import script from "./ErrosSync.vue?vue&type=script&lang=js&"
export * from "./ErrosSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports